export default {
    seo: {
        home: {
            title: "CodePro - Learn Programming Interactively",
            description: "Learn programming through interactive lessons."
        }
    },

    home: {
        heading: "Learn Programming Interactively",
        subtitle: "Interactive exercises and coding challenges.",
        download: "Download Android App",
        downloadUrl: "https:/"
    }
}